import { signOut } from 'aws-amplify/auth';
import { clearDevToken, getDevToken } from './devAuth';

/**
 * App-wide sign-out. A dev bypass session is purely
 * local, so clearing the stored token is the whole sign-out — no AWS call is
 * made. Real Cognito sessions defer to Amplify as before.
 */
export const signOutApp = async (): Promise<void> => {
  if (getDevToken() !== null) {
    clearDevToken();
    return;
  }
  await signOut();
};
